export default "__VITE_ASSET__DHr6V$ch__"